import { requestWithAuth } from "./http";

const API_BASE = "https://api.touchprop.com/api/v1/withdrawals";
const FALLBACK_MESSAGE = "\u062e\u0637\u0627 \u062f\u0631 \u0627\u0631\u062a\u0628\u0627\u0637 \u0628\u0627 \u0633\u0631\u0648\u0631 \u0628\u0631\u062f\u0627\u0634\u062a";

const request = (path, options = {}) =>
  requestWithAuth(`${API_BASE}${path}`, options, { fallbackMessage: FALLBACK_MESSAGE });

export function getWithdrawals() {
  return request("/withdrawals/");
}

export function createWithdrawal(payload) {
  return request("/withdrawals/", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}
